import { apiClient } from './apiClient';

export type User = {
  id: number;
  fullName: string;
  username: string;
  roleId: number;
};

export function login(payload: {
  username: User['username'];
  password: string;
}) {
  return apiClient.post<{ user: User }>('/login', payload);
}

export function logout() {
  return apiClient.post('/logout', {});
}

export function whoAmI() {
  return apiClient.get<{ user: User }>('/login/whoami', {});
}

export function resetPassword(payload: {
  newPassword: string;
  token: string | null;
}) {
  return apiClient.post('/reset-password', payload);
}

export function requestPasswordReset(payload: { username: User['username'] }) {
  return apiClient.post('/reset-password/request', payload);
}
